/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  FindProductsCustomFieldsQueryResponse,
  FindProductsCustomFieldsQueryParams,
} from "../types/FindProductsCustomFields.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const findProductsCustomFieldsQueryKey = (
  params: FindProductsCustomFieldsQueryParams
) =>
  [
    { url: "/v1/product/find-products-custom-fields" },
    ...(params ? [params] : []),
  ] as const

export type FindProductsCustomFieldsQueryKey = ReturnType<
  typeof findProductsCustomFieldsQueryKey
>

/**
 * @summary Find products custom fields
 * {@link /v1/product/find-products-custom-fields}
 */
export async function findProductsCustomFields(
  params: FindProductsCustomFieldsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    FindProductsCustomFieldsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/product/find-products-custom-fields`,
    params,
    ...requestConfig,
  })
  return res
}

export function findProductsCustomFieldsQueryOptions(
  params: FindProductsCustomFieldsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = findProductsCustomFieldsQueryKey(params)
  return queryOptions<
    ResponseConfig<FindProductsCustomFieldsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<FindProductsCustomFieldsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return findProductsCustomFields(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Find products custom fields
 * {@link /v1/product/find-products-custom-fields}
 */
export function useFindProductsCustomFields<
  TData = ResponseConfig<FindProductsCustomFieldsQueryResponse>,
  TQueryData = ResponseConfig<FindProductsCustomFieldsQueryResponse>,
  TQueryKey extends QueryKey = FindProductsCustomFieldsQueryKey,
>(
  params: FindProductsCustomFieldsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<FindProductsCustomFieldsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? findProductsCustomFieldsQueryKey(params)

  const query = useQuery(
    {
      ...findProductsCustomFieldsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
